import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 md:gap-3" }
const _hoisted_2 = { class: "flex gap-5 flex-col md:flex-row" }

import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import RACQFormKit from '../RACQFormKit/RACQFormKit.vue';
import Alert from '../Alert/Alert.vue';
import { IAlert } from '@/interfaces/forms/alert-interface';
import { AlertTypes } from '@/enums/alert-types-enum';
import { computed, ref, watch } from 'vue';

// Define props and emitters
// ------------------------------------------------------------- //

export default /*@__PURE__*/_defineComponent({
  __name: 'SendEmail',
  props: /*@__PURE__*/_mergeModels({
    bindings: {},
    emailHeading: {},
    emailSubheading: {},
    emailButtonText: {},
    successText: {},
    errorText: {},
    infoText: {},
    isLoading: { type: Boolean },
    showSuccess: { type: Boolean },
    showError: { type: Boolean },
    showInfo: { type: Boolean },
    sendButtonDisabled: { type: Boolean },
    plainStyle: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(['sendEmailFired'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emailAddress = _useModel<string>(__props, "modelValue");

const emit = __emit;

watch(
  () => emailAddress.value,
  (newVal) => {
    formData.value[props.bindings.name] = newVal ?? '';
  }
);

// Define Component state
// ------------------------------------------------------------- //
const formData = ref<Record<string, string>>({});

const sendButtonDisabled = computed(() => {
  return (
    !formData.value?.[props.bindings.name] || props.isLoading || props.bindings.disabled || props.sendButtonDisabled
  );
});

const alert = computed<IAlert | null>(() => {
  if (props.showSuccess) {
    return {
      showIcon: true,
      alertType: AlertTypes.success,
      text: props.successText.value,
    };
  } else if (props.showInfo) {
    return {
      showIcon: true,
      alertType: AlertTypes.info,
      text: props.infoText.value,
    };
  } else if (props.showError) {
    return {
      showIcon: true,
      alertType: AlertTypes.danger,
      text: props.errorText.value,
    };
  }
  return null;
});

// Define Functions
// ------------------------------------------------------------- //

const emailSendClick = (values: Record<string, string>) => {
  console.debug(formData.value);
  !sendButtonDisabled.value && emit('sendEmailFired', values);
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_ctx.emailHeading)
        ? (_openBlock(), _createBlock(_unref(RichText), {
            key: 0,
            field: _ctx.emailHeading,
            class: "text-lg-bold text-racq-dark-grey"
          }, null, 8, ["field"]))
        : _createCommentVNode("", true),
      (_ctx.emailSubheading)
        ? (_openBlock(), _createBlock(_unref(RichText), {
            key: 1,
            field: _ctx.emailSubheading,
            class: "text-base text-racq-med-grey mt-1"
          }, null, 8, ["field"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(
        _ctx.plainStyle
          ? 'px-5 py-8 bg-racq-anti-flash-white rounded'
          : 'px-5 md:px-8 pt-5 md:pt-6 pb-8 bg-racq-anti-flash-white border-2 rounded border-solid border-racq-pale-blue-border shadow-lg'
      )
    }, [
      _createVNode(_component_FormKit, {
        modelValue: formData.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData).value = $event)),
        type: "form",
        novalidate: "",
        disabled: _ctx.bindings.disabled,
        onSubmit: emailSendClick
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(['flex flex-col gap-4 md:gap-5', { 'md:px-16': _ctx.plainStyle }])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(RACQFormKit, {
                bindings: {
                ..._ctx.bindings,
                helpClass: 'mt-1',
                innerClass: '',
                outerClass: _ctx.plainStyle ? 'w-full' : 'md:racq-w-xl w-full',
              }
              }, null, 8, ["bindings"]),
              _createElementVNode("div", null, [
                _createVNode(_component_FormKit, {
                  type: "submit",
                  loading: _ctx.isLoading,
                  disabled: _ctx.plainStyle ? undefined : sendButtonDisabled.value,
                  inputClass: 
                  _ctx.plainStyle
                    ? 'btn btn-md btn-secondary w-full md:w-auto md:!min-w-[130px]'
                    : 'btn btn-md btn-secondary md:mt-7 w-full md:w-auto md:!min-w-[130px]'
                ,
                  label: _ctx.emailButtonText.value
                }, null, 8, ["loading", "disabled", "inputClass", "label"])
              ])
            ]),
            (alert.value)
              ? (_openBlock(), _createBlock(Alert, {
                  key: 0,
                  alert: alert.value
                }, null, 8, ["alert"]))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ], 2)
  ]))
}
}

})